<template>
	<div>
		<h1 class="page-header"><i class="fa fa-envelope"></i> Emailek</h1>
		<hr>
		<panel title="emailek">
			<Loading v-if="!emails"></Loading>
			<NoRecords v-else-if="emails.length == 0" main_icon="fa fa-envelope" value="false" title="Nincsenek szerkeszthető emailek"></NoRecords>
			<div v-else class="table-responsive">
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th>Email tárgya</th>
							<th>Megjegyzés</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(email,id) in emails" :key="id">
							<td class="align-middle">
								{{email.subject}}
							</td>
							<td>
								<div class="input-group">
									<textarea class="form-control" v-model="email.description" cols="30" rows="2"></textarea>
									<button class="btn btn-success" @click="updateEmail(email)"><i class="fa fa-save fa-2x"></i></button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</panel>
	</div>
</template>

<script>
	import Email from '../../apis/Email';
	export default {
		data() {
			return {
				emails:null
			}
		},
		created() {
			Email.index()
			.then(response => {
				this.emails = response.data
			})
		},
		methods: {
			updateEmail(email){
				Email.update(email.id,{description:email.description})
			}
		}
	};
</script>